import ImaginePay, { ImaginePayBlock } from './components/ImaginePay';
import ImaginePayCardToken, { ImaginePayCardTokenBlock } from './components/ImaginePayCardToken';
export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  ImaginePayBlock(bm, labelShoppingCartCategory, labels.imaginePay, types.imaginePay);
  ImaginePay(dc, labels.imaginePay, types.imaginePay, opts);
  ImaginePayCardTokenBlock(
    bm,
    labelShoppingCartCategory,
    labels.imaginePayToken,
    types.imaginePayToken,
  );
  ImaginePayCardToken(dc, labels.imaginePayToken, types.imaginePayToken, opts);
};
